import { useEffect, useState } from "react";
import { Alert, Button, Checkbox, CircularProgress, Grid, Typography } from "@mui/material";
import { Clear as ClearIcon, AddPhotoAlternate as AddPhotoAlternateIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useMutation } from "react-query";
import { saveImage, deleteImage } from "services/api/ImageList";
import ToolBar from "components/ToolBar";
import { useDropzone } from "react-dropzone";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";
//import { hasAspectRatio, validateDimensionsImage } from "../helpers";
import CropImage from "./CropIMage";

export default function ImageManagerImages({ menu, dataImageList, selectedImageList, setSelectedImageList, setDisableMainButtons, reportAction }) {
  const [isSaving, setIsSaving] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [dataImageListFilter, setDataImageListFilter] = useState(null);
  const [uploadFilesDND, setUploadFilesDND] = useState([]);
  const [deletedFilesDND, setDeletedFilesDND] = useState([]);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const [filesDND, setFilesDND] = useState([])
  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': [] },
    onDrop: (acceptedFiles) => {

      const acceptedFilesFormat = acceptedFiles.map((file) => {
        return {
          file: file,
          size: file.size,
          type: file.type,
          name: file.name
        }
      })

      const filesPrevious = [...filesDND]
      filesPrevious.push(...acceptedFilesFormat)
      setFilesDND(filesPrevious);
      console.log("filesPrevious", filesPrevious)
    }
  })

  useEffect(() => {
    if (dataImageList !== undefined && dataImageList !== null && dataImageList !== "")
      setDataImageListFilter(dataImageList)
  }, [dataImageList])

  const mutationSave = useMutation(saveImage, {
    onSuccess: (data) => {
      setIsSaving(false)
      setDisableMainButtons(false)
      if (data.status === "error") { reportAction('addImageList', false, { message: 'Error al guardar la imagen' }, false) }
      else {
        handleUpdateFiledUpdated(data.name)
      }
    }
  })

  const handleUpdateFiledUpdated = (name) => setUploadFilesDND(uploadFilesDND => [...uploadFilesDND, name])

  useEffect(() => {
    if (uploadFilesDND.length > 0 && filesDND.length > 0 && uploadFilesDND.length === filesDND.length) {
      handleClearImage()
      reportAction('addImageList', false, {}, true)
      setTimeout(() => { setUploadFilesDND([]); setFilesDND([]) }, 5000)
    }
  }, [uploadFilesDND])

  const mutationDelete = useMutation(deleteImage, {
    onSuccess: (data) => {
      setIsDeleting(false)
      setDisableMainButtons(false)
      if (data.status === "error") { reportAction('removeImageList', false, { message: 'Error al eliminar la imagen' }, false) }
      else {
        handleUpdateFiledDeleted(data.delete)
      }
    }
  })

  const handleUpdateFiledDeleted = (id) => setDeletedFilesDND(deletedFilesDND => [...deletedFilesDND, id])

  useEffect(() => {
    if (deletedFilesDND.length > 0 && selectedImageList.length > 0 && deletedFilesDND.length === selectedImageList.length) {
      setSelectedImageList([], 2)
      reportAction('removeImageList', false, {}, true)
      setTimeout(() => { setDeletedFilesDND([]); }, 5000)
    }
  }, [deletedFilesDND])

  const handleSubmitImages = () => {
    const files = filesDND;
    if (files.length === 0) {
      alert("No fue seleccionado ningun archivo");
      return;
    }
    setIsSaving(true)
    setDisableMainButtons(true)
    for (let index = 0; index < files.length; index++) {
      const formData = new FormData();
      formData.append("file", files[index].file);
      mutationSave.mutate({ id: menu, params: formData })
    }
  };

  const handleDeleteImage = () => {
    setIsDeleting(true)
    setDisableMainButtons(true)
    setOpenConfirmDelete(false)
    for (let index = 0; index < selectedImageList.length; index++) {
      mutationDelete.mutate({ id: menu, params: selectedImageList[index] })
    }
  }

  const handleClearImage = () => { setFilesDND([]) }

  const handleSearchImageCategory = (e) => {
    const dataFilter = dataImageList.filter(item => item.filename.toLowerCase().includes(e.target.value.toLowerCase(), 0))
    setDataImageListFilter(dataFilter)
  }

  const handleSelectedImage = (e, image) => {
    if (e.ctrlKey) { setSelectedImageList(image, 1) } else { setSelectedImageList(image, 0) }
  }

  const handleSelectedImageWithCheckbox = (image) => setSelectedImageList(image, 1)

  /* cropped image */
  const [openCropImageDialog, setOpenCropImageDialog] = useState(false)
  const [imageToCrop, setImageToCrop] = useState(null)
  const [imageToCropMetadata, setImageToCropMetadata] = useState(null)
  const [imagePositionToCrop, setImagePositionToCrop] = useState(null)
  const handleSeletectImageToCrop = (item, position) => {
    setImagePositionToCrop(position)
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result //.replace('data:', '').replace(/^.+,/, '');
      //console.log(base64String);
      setImageToCrop(base64String)
      setImageToCropMetadata({ type: item.type, name: item.name })
      setOpenCropImageDialog(true)
    };
    reader.readAsDataURL(item.file);
  }
  const handleCloseCropImegeDialog = () => setOpenCropImageDialog(false)
  const handleReceiveCroppedImage = (image) => {
    //console.log("handleReceiveCroppedImage", image)
    const filesPrevious = [...filesDND]
    filesPrevious[imagePositionToCrop] = { 
      file: image,
      size: image.size,
      type: image.type,
      name: image.name
    }
    setFilesDND(filesPrevious);
    setOpenCropImageDialog(false)
  }

  /* Actions over filesDND (wait list to upload) */
  const handleDeleteFileDND = (index) => {
    const filesPrevious = [...filesDND]
    filesPrevious.splice(index, 1)
    setFilesDND(filesPrevious);
  }

  //const handleValidateAspectRatio = async(file, w, h) => await hasAspectRatio(file, w, h)

  return (<>
    <div className="im-images-categories-container">
      <div className="im-images-toobox-container"> <ToolBar searchFunction={handleSearchImageCategory} /> </div>
      <div className="im-images-container" style={{ overflowY: "scroll", maxHeight: 325 }}>
        {dataImageListFilter !== null && dataImageListFilter.map((image, index) =>
          <div className={`im-image-card ${selectedImageList && selectedImageList.findIndex(i => i._id === image._id) !== -1 ? 'im-image-card-selected' : ''}`} key={index} onClick={(e) => handleSelectedImage(e, image)}>
            <div style={{ height: 80 }}>
              <img src={image.url} alt={image.id} style={{ maxHeight: "80px" }} />
            </div>
            <div>
              <Checkbox
                checked={selectedImageList && selectedImageList.findIndex(i => i._id === image._id) !== -1}
                onChange={(e) => handleSelectedImageWithCheckbox(image)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
    <div className="im-images-actions-container">
      {(selectedImageList && selectedImageList.length === 0) ?
        <div className="im-images-actions-upload">
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })} style={{ border: "1px dashed gray", padding: 10 }}>
              <input {...getInputProps()} />
              <p>Arrastra y suelta los archivos aquí o da clic para seleccionar los archivos</p>
            </div>
            {filesDND.length > 0 ?
              <div style={{ marginTop: 12 }}>
                {isSaving ? <CircularProgress /> : <>
                  <Button variant="outlined" size="small" startIcon={<AddPhotoAlternateIcon />} onClick={() => handleSubmitImages()}> Agregar </Button>
                  <Button variant="outlined" size="small" startIcon={<ClearIcon />} onClick={handleClearImage}> Cancelar </Button>
                </>}
                <h4>Archivos</h4>
                <Grid container spacing={2} sx={{ height: 200, overflow: "scroll" }}>
                  {filesDND.map((item, index) => (
                    <Grid key={item.file.path} item xs={12}>
                      <div style={{ display: "flex" }}>
                        <div>
                          <Button><DeleteIcon color="error" onClick={() => handleDeleteFileDND(index)} /></Button>
                        </div>
                        <img src={URL.createObjectURL(item.file)} alt={item.file.path} style={{ maxWidth: "100px", height: "fit-content" }} />
                        <div style={{ textAlign: "left", paddingLeft: 10 }}>
                          <div style={{ fontSize: 12 }}>{(item.file.size / 1024).toFixed(2)} KB</div>
                          {item.file.size > 300000 ? <div style={{ fontSize: 12, color: "red" }}>El peso de la imagen no debe ser mayor a 300 KB</div> : null}
                          <div><Button onClick={() => handleSeletectImageToCrop(item, index)}>Reestructurar</Button></div>
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </div>
              : null}
            {uploadFilesDND.map((f, i) => (
              <Alert key={i} severity="success">{f} ha sido subida</Alert>
            ))}
          </section>
        </div>
        :
        <div className="im-images-actions-delete">
          {selectedImageList && selectedImageList.length === 1 ?
            <img src={selectedImageList[0].url} alt={selectedImageList[0].identifier} style={{ width: "100%", height: "150px", maxWidth: "fit-content" }} />
            : <p>Multiples imágenes seleccionadas</p>
          }
          <br />
          {isDeleting ? <CircularProgress /> :
            <Button variant="outlined" size="small" color="error" startIcon={<DeleteIcon />} onClick={() => setOpenConfirmDelete(true)}> Eliminar ({selectedImageList.length}) </Button>
          }
        </div>
      }
    </div>
    <FlexibleWidthDialog open={openConfirmDelete} title="Eliminación de imagen"
      actions={<>
        <Button color="error" onClick={() => handleDeleteImage()} > SI, eliminar</Button>
        <Button onClick={() => setOpenConfirmDelete(false)} >No, cerrar</Button>
      </>}
    >
      <Typography sx={{ fontWeight: "bold" }}>¿Estas seguro de querer eliminar la imagen?</Typography>
    </FlexibleWidthDialog>
    <CropImage
      open={openCropImageDialog}
      image={imageToCrop}
      imageMetadata={imageToCropMetadata}
      close={handleCloseCropImegeDialog}
      returnImageCropped={handleReceiveCroppedImage} />
  </>)
}

//https://blog.openreplay.com/image-manipulation-with-react-easy-crop/
//https://www.w3docs.com/snippets/html/how-to-display-base64-images-in-html.html
//https://pqina.nl/blog/convert-a-file-to-a-base64-string-with-javascript/
//https://pqina.nl/blog/convert-a-blob-to-a-file-with-javascript/